import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';

const BASE_CLASS =
  'tw:typography-labels-1 tw:relative tw:flex tw:h-10 tw:w-fit tw:shrink-0 tw:cursor-pointer tw:items-center tw:justify-center tw:gap-2.5 tw:border tw:px-[18px] tw:text-gray-1 tw:outline-none tw:transition-colors tw:duration-200';

/**
 * The button that opens a page's filters — the Smart Filter panel on desktop, the filters dialog
 * on smaller screens. The label is projected next to the funnel icon; the number of applied
 * filters sits as a badge on the top corner. `active` is the look of an open panel.
 */
@Component({
  selector: 'button[fr8botUiFiltersButton]',
  templateUrl: './filters-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconUIComponent],
  host: {
    type: 'button',
    '[class]': 'hostClass()',
  },
})
export class FiltersButtonUIComponent {
  readonly count = input(0);
  readonly active = input(false);

  protected readonly hostClass = computed(
    () =>
      `${BASE_CLASS} ${
        this.active()
          ? 'tw:border-transparent tw:bg-gray-7 tw:hover:bg-gray-6'
          : 'tw:border-gray-4 tw:bg-transparent tw:hover:border-gray-2 tw:hover:text-white'
      }`,
  );
}
